import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { IconButton } from '../Button/IconButton';

export enum BannerType {
  INFO = 'info',
  CRITICAL = 'critical',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum BannerImpact {
  LOW = 'low',
  HIGH = 'high',
}

export type BannerProps = {
  children?: React.ReactNode;
  className?: string;
  impact?: BannerImpact | `${BannerImpact}`;
  name?: string;
  /**
   * Renders the banner's own dismiss control, in its top-right corner, and is called when the
   * reader uses it. Going away is the caller's to do - the banner has no say in whether it is
   * rendered.
   */
  onDismiss?: () => Promise<unknown> | void;
  type?: BannerType | `${BannerType}`;
};

export const Banner = ({
  className,
  children,
  impact = BannerImpact.LOW,
  name,
  onDismiss,
  type = BannerType.INFO,
}: BannerProps) => (
  <div
    className={AttrsHelper.formatClassname(
      'banner',
      `impact-${impact}`,
      `type-${type}`,
      className
    )}
    data-test={name}
  >
    {/* Before the words because it floats: a float only shortens the lines that come after it. */}
    {onDismiss ? (
      <IconButton
        /*
          `fixed-dimension` holds the 32px box on a small screen, where an icon button otherwise
          grows to a 44px touch target - taller than a one-line banner, so it hangs out the bottom.
        */
        className="banner-dismiss fixed-dimension"
        icon="x-mark"
        name="BANNER_DISMISS_BUTTON"
        onClick={async () => onDismiss()}
        title="Dismiss"
        variation="minimal"
      />
    ) : null}
    <Paragraph>{children}</Paragraph>
  </div>
);
